export const getDeleteButtonAnalytics = () => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction: "my account:account settings:delete account",
    eventName: "my account:account settings:delete account",
    eventStatus: "n/a",
    eventMsg: "n/a",
    eventType: "navigation",
    internalLinkName: "delete account",
    internalLinkPosition: "my account",
    internalLinkType: "my account:account management",
    internalLinkURL: "n/a",
    internalLinkZoneName: "my account:account settings",
  })
}

export const getEventInfo = (type = "") => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction: `my account:account settings:modal:delete your account:${type}`,
    eventName: `my account:account settings:modal:delete your account:${type}`,
    eventStatus: "n/a",
    eventMsg: "n/a",
    eventType: "navigation",
    internalLinkName: `${type}`,
    internalLinkPosition: "my account",
    internalLinkType: "my account:account management",
    internalLinkURL: "n/a",
    internalLinkZoneName:
      "my account:account settings:modal:delete your account",
  })
}
